export const ACTIONS = {
  SHOW_MODAL: 'show_modal',
  HIDE_MODAL: 'hide_modal',
};
